import { postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const emission = apiUrl + "/emission";
const routes = {
  label: "Emission",
  root: emission,
  get_by_structure_id: emission + "/get_by_structure_id",
  get_by_supply_chain_id: emission + "/get_by_supply_chain_id",
  get_by_corporate_id: emission + "/get_by_corporate_id",
  save: emission + "/save",
  new: emission + "/new",
  update: emission + "/update",
  delete: emission + "/delete",
  duplicate: emission + "/duplicate",
};
export const Emission = {
  getEmissionsBySupplyChainId: (body) => postWithToken(routes.get_by_supply_chain_id, body),
  getEmissionsByStructureId: (id) => postWithToken(routes.get_by_structure_id, { id }),
  getEmissionsByCorpId: (body) => postWithToken(routes.get_by_corporate_id, body),

  save: (body) => postWithToken(routes.save, body),
  new: (body = {}) => postWithToken(routes.new, body),
  update: (emissions) => postWithToken(routes.update, emissions),
  delete: (ids) => postWithToken(routes.delete, { ids }),
  duplicate: (ids) => postWithToken(routes.duplicate, { ids }),
};
